import { default as planModule } from './module/routes'
import { default as planType } from './type/routes'
import { default as planChargeType } from './charge-type/routes'
import { default as plan } from './plan/routes'
import { default as additionalService } from './additional-service/routes'
import { default as installment } from './installment/routes'

export default [
    ...planModule,
    ...planType,
    ...planChargeType,
    ...additionalService,
    ...installment,
    ...plan
]
